import React from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  Badge,
  Panel,
} from 'react-bootstrap';
import GroupDetailModal from './GroupDetailModal';
import { Modal} from 'react-bootstrap';

function findById(value) {
  console.log('findById ', value.id, this);
  return value.id === Number(this);
}

const renderToolbar = (value, name, edit, removeConfirm, members, readOnly) => {
  if (readOnly) {
    return (<div>{name} ({members} members)</div>);
  }
  return (
    <ButtonGroup>
      <Button name="Edit" bsSize="small" bsStyle="success" title="Edit Group" data-item={value} onClick={edit}>
        <i className="fa fa-pencil" />
      </Button>
      <Button name="Remove" bsSize="small" bsStyle="success" title="Delete Group" data-item={value} onClick={removeConfirm}>
        <i className="fa fa-trash-o" />
      </Button>
      &nbsp;{name} ({members} members)
    </ButtonGroup>);
};
// <Badge>{members}</Badge>
class TourRosterGroups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      opened: true,
      groupId: 0,
      showConfirmDialog: false,
      modalText: '',
    };
    this.toggleBox = this.toggleBox.bind(this);    
    this.removeGroupAction = this.removeGroupAction.bind(this);
    this.removeConfirm = this.removeConfirm.bind(this);
    this.showGroup = this.showGroup.bind(this);
    this.closeModal = this.closeModal.bind(this);    
  }
  toggleBox() {
    const { opened } = this.state;
    this.setState({
      // toggle value of `opened`
      opened: !opened,
    });
  }
  closeModal() {
    this.setState({
      show: false,
      group: null,
      showConfirmDialog: false,
    });
  }
  removeGroupAction() {   
    const id = (this.state.groupId) ? this.state.groupId : 0;    
    if (id) {
      this.findGroup(this.state.group);
      this.props.removeGroup(this.findGroup(id));
      this.setState({ showConfirmDialog: false, groupId: 0, modalText: '' });
    }
  }
  removeConfirm(e) {    
    const id = e.currentTarget.getAttribute('data-item');
    e.preventDefault();    
    this.setState({ showConfirmDialog: true, groupId: id, modalText: 'Are you sure want to delete group?' });
  }
  showGroup(e) {
    e.preventDefault();
    const id = e.currentTarget.getAttribute('data-item');
    if (id) {
      this.setState({
        group: id,
        show: true,
      });
    }
  }
  findGroup(id) {
    const idx = this.props.groups.findIndex(findById, id);
    if (idx === -1) {
      console.log('findGroup that should not happen...', id);
      return {};
    }
    return this.props.groups[idx];
  }

  render() {
    
    const groups = this.props.groups.map(group =>
      <li key={group.id} >
        { renderToolbar(
            group.id,
            group.name,
            this.showGroup,            
            this.removeConfirm,
            group.members_count,
            this.props.readOnly,
          ) }
      </li>,
    );
    const { opened } = this.state;
    return (
      <div>
        <h3>Sub-Group <span className="badge">{groups.length}</span>
          <i
            className={opened ? 'fa fa-angle-up' : 'fa fa-angle-down'}
            aria-hidden="true"
            onClick={this.toggleBox}
          />
        </h3>
        { opened && (
          <ul className="groups">
            {groups}
          </ul>
        )}
        { this.state.show && (
        <GroupDetailModal
          group={this.findGroup(this.state.group)}
          show={this.state.show}
          onClose={this.closeModal}
          editGroup={this.props.editGroup}
          editing={!this.props.readOnly}
          addGroup={false}
          addMember={this.props.addMember}
        />
        )}

        {this.state.showConfirmDialog && (<Modal show={this.state.showConfirmDialog} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Group</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <p> {this.state.modalText !== '' ? this.state.modalText : 'Are you sure want to delete group?'}</p>

            <ButtonToolbar style={{ float: 'right' }}>
              <Button
                bsStyle="success"
                onClick={this.removeGroupAction}
              >
                Confirm
              </Button>
              <Button
                bsStyle="success"
                onClick={this.closeModal}
              >
                Cancel
              </Button>
            </ButtonToolbar>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
        )}

      </div>
    );
  }
}
export default TourRosterGroups;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRosterGroups.js